import { KC_DateRangePicker } from "../designsystem/KC_DateRangePicker/KC_DateRangePicker";
import { tt } from "../utils/i18n/i18n";
import React from "react";

export default function DateRangePickerReduxWrapper() {
  return <KC_DateRangePicker label={tt("period")} />;
}
